module.exports = __webpack_public_path__ + "img/pt-4.4369a64e.jpg";